module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._m(0), _vm._v(" "), _c('img', {
    staticClass: "img_material",
    attrs: {
      "src": _vm.img.material
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "img_next",
    attrs: {
      "src": _vm.img.next
    },
    on: {
      "click": function($event) {
        _vm.$store.state.oHomePage.index += 1
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('p', [_vm._v("选择‘酷联客’物联网应用方案，唯快不破")]), _vm._v(" "), _c('p', {
    staticClass: "sub"
  }, [_vm._v("我们专业提供设备智能化、物联网控制解决方案")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-3da1aaea"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/page_1.vue
// module id = 773
// module chunks = 1